import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { DocumentRepo } from "../../../Component/Model/Dto/EmploymentEquity/DocumentRepo";
import { DateFormatter} from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";

interface DocumentRepoColumn {
    Id:                     number;
    Description:            string;
    FileName:               string;
    CreatedDate:            string | undefined;
    Actions:                ActionType[];
}

interface DocumentRepoTable {
    columns: Array<TableColumn>;
    rows: Array<DocumentRepoColumn>;
}

export function DocumentRepoWithActionsTableMapper(dataObject:  DocumentRepo.Document[], handleView: (id: number) => void, handleDelete: (id: number) => void ): DocumentRepoTable {
    const columns = [
        { Header: 'Description', accessor: 'Description', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'File Name', accessor: 'FileName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Created Date', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },

    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item:  DocumentRepo.Document) => ({
            Id: item.Id,
            Description: item.Description,
            FileName: item.FileName,
            CreatedDate: DateFormatter(item.CreatedDate.toString()),
            Actions: [
                { 
                    label: 'View/Edit',
                    action: () => {handleView(item.Id)},
                    key: item.Id.toString(),
                    icon: { color: 'info', name: 'visibility' } 
                },
                { 
                    label: 'Delete',
                    action: () => {handleDelete(item.Id)},
                    key: item.Id.toString(),
                    icon: { color: 'error', name: 'delete' } 
                }
            ]
            
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}